module.exports = __webpack_public_path__ + "media/images/amenities_icons/sr_equipment-e963313f3383b71a8598a924024c0f79.svg";